<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 點數兌換券分析</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2">票券搜尋：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="ticketSearch" placeholder="票券名稱或編號">
                  </div>
                </div>
                <div class="row mt-2">
                  <label class="control-label col-md-2 mt-2">日期區間：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-warning text-white" @click="getinformationcoupon(1)">查詢</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row" style="height: 280px">
          <div class="col-lg-6">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th>項目</th>
                  <th>張數</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>使用張數</td>
                  <td>{{used_coupon}}</td>
                </tr>
                <tr>
                  <td>失效張數</td>
                  <td>{{invalid_coupon}}</td>
                </tr>
                <tr>
                  <td>未使用張數</td>
                  <td>{{not_used_coupon}}</td>
                </tr>
                <tr>
                  <td>兌換張數</td>
                  <td>{{total_coupon}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-lg-6">
            <IEcharts :option="pie" :loading="loading" @ready="onReady"></IEcharts>
          </div>
        </div>
      </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th>項次</th>
                  <th>電子券</th>
                  <th>兌換張數</th>
                  <th>使用張數</th>
                  <th>失效張數</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x, index) in coupon" :key="x.id">
                  <td>{{((currentPage-1)*perpage+index+1)}}</td>
                  <td>{{x.Name}}</td>
                  <td>{{x.Count}}</td>
                  <td>{{x.UseCoupon}}</td>
                  <td>{{x.UnusedCoupon}}</td>
                </tr>
              </tbody>
            </table>
            <div class="row" style="padding: 0 1rem">
              <b-pagination size="md" :total-rows="count" v-model="currentPage" :per-page="perpage" @change="getinformationcoupon"></b-pagination>
              <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{count}}筆</label>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import IEcharts from 'vue-echarts-v3/src/full.js'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
export default {
  name: 'echarts',
  components: {
    IEcharts
  },
  data () {
    return {
      sdate: '',
      edate: '',
      ticketSearch: '', // 票券名稱或編號搜尋

      used_coupon: 0,
      invalid_coupon: 0,
      not_used_coupon: 0,
      total_coupon: 0,

      // pie chart
      serverdata: [],
      instances: [],
      loading: false,

      pie: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} 張({d} %)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            fontWeight: 'bold',
            fontSize: 18
          },
          data: ['使用張數', '失效張數', '未使用張數']
        },
        series: [{
          name: '電子券',
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          itemStyle: {
            normal: {
              label: {
                textStyle: {
                  fontSize: 18
                }
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: [
            {value: 0, name: '使用張數', itemStyle: {normal: {color: '#004f2d'}}},
            {value: 0, name: '失效張數', itemStyle: {normal: {color: '#138045'}}},
            {value: 0, name: '未使用張數', itemStyle: {normal: {color: '#c4e1b2'}}}]
        }]
      },
      // pie chart

      coupon: [],
      currentPage: 1,
      perpage: 20,
      count: 0,
      startRowNum: 0,
      endRowNum: 0
    }
  },
  created () {
    this.setdate()
    this.getinformationcoupon(1)
    this.FunctionPermission = getFunctionPermission('F13') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    getinformationcoupon (currentPage) {
      var edate = '9999-12-31'
      if (this.edate !== '') {
        edate = this.edate
      }
      if (this.sdate > edate) {
        miniToastr.success('請選擇正確的效期區間')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/information/gift/certificates/v1', {
        sdate: this.sdate,
        edate: this.edate,
        ticketSearch: this.ticketSearch, // 票券搜尋
        toPage: currentPage,
        perPage: this.perpage
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.pie.series[0].data = []
            this.coupon = response.data.data
            this.used_coupon = response.data.usecoupon
            this.currentPage = currentPage
            this.pie.series[0].data.push({value: this.used_coupon, name: '使用張數', itemStyle: {normal: {color: '#004f2d'}}})
            this.invalid_coupon = response.data.invalidcoupon
            this.pie.series[0].data.push({value: this.invalid_coupon, name: '失效張數', itemStyle: {normal: {color: '#138045'}}})
            this.not_used_coupon = response.data.unusedcoupon
            this.pie.series[0].data.push({value: this.not_used_coupon, name: '未使用張數', itemStyle: {normal: {color: '#c4e1b2'}}})
            this.total_coupon = response.data.totalcoupon
            this.count = (response.data.count === undefined) ? 0 : response.data.count
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.perpage > response.data.count) ? response.data.count : (this.currentPage * this.perpage) >= response.data.count ? response.data.count : this.currentPage * this.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 0)
      // 若三個月後的最後一天比當天的日期大，則可以設定當天日期為三個月後的日期
      if (firstDay.getDate() >= date.getDate()) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 3, date.getDate())
      }
      var lastDay = date
      this.sdate = this.dateFormat(firstDay)
      this.edate = this.dateFormat(lastDay)
    },
    dateFormat (date) {
      var year = date.getFullYear()
      var mon = ('0' + (date.getMonth() + 1)).substr(-2, 2)
      var day = ('0' + date.getDate()).substr(-2, 2)
      return year + '-' + mon + '-' + day
    },
    goToTicketHistory () {
      this.$router.push({ name: 'information_tickethistory_list' })
    }
  }
}
</script>
<style scoped>
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
  .font_text {
    font-size: 19px;
    margin: 6px 0 7px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/information/coupon/List.vue